export default {
  Title: 'Molecular',
  DateCreateFrom: 'Date Created From',
  DateCreateTo: 'To',
  DateReceiveFrom: 'Date Received From',
  DateReceiveTo: 'To',
  PathoNo: 'Patho No.',
  HLN: 'HLN',
  MLCStatus: 'ML Status',
  PatientName: 'Patient Name',
  ReceivedDate: 'Received Date',
  Sex: 'Sex',
  Status: 'Status',
  Select: 'Select',
  Block: 'Block',
  Slide: 'Slide',
  Find: 'Find',
  Add: 'Add',
  SentDate: 'Sent Date',
  SentTo: 'Sent To',
  Remark: 'Remark',
  BlockNo: 'Block No',
  HN: 'HN',
  PrintSlide: 'Print Slide',
  Export: 'Export',
  SlidePrepare: 'Slide Preparation',
  Staining: 'Staining',
}
